import { roles } from "../constants/roles";

export const isPartnerRole = (role) => 
    Number(role) === Number(roles.PARTNER_ADMIN) 
    || Number(role) === Number(roles.PARTNER_EDITOR)
    || Number(role) === Number(roles.PARTNER_REPORTER);